export default __webpack_public_path__ + "static/media/head-divider.9b79d0f7.svg";